<template>
    <div>
        <osobe-navigation
            :id="osoba_id"
            :breadcrumbs="breadcrumbs"
        >
        </osobe-navigation>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Dodatna aktivnost: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <osoba-dodatna-aktivnost-forma
                    :disabled="false"
                    :id="id"
                    :modal="false"
                    :action="'edit'"
                    @returnData="setData"
                >
                </osoba-dodatna-aktivnost-forma>
            </div>
        </div>
    </div>
</template>

<script>
import OsobeNavigation from "../OsobeNavigation";
import OsobaDodatnaAktivnostForma from "./OsobaDodatnaAktivnostForma";
export default {
    name: "OsobaDodatnaAktivnostEdit",
    components: { OsobaDodatnaAktivnostForma, OsobeNavigation },
    data(){
        return {
            breadcrumbs: [],
            id:this.$route.params.osoba_dodatna_aktivnost_id,
            osoba_id: this.$route.params.osoba_id,
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/osobe/' + this.osoba_id + '/dodatne-aktivnosti',
                    name: 'Dodatne aktivnosti'
                },
                {
                    path: '/osobe/' + this.osoba_id + '/dodatne-aktivnosti/' + this.id,
                    name: 'Dodatna aktivnost: ' + this.naziv
                },
                {
                    path: '/osobe/' + this.osoba_id + '/dodatne-aktivnosti/' + this.id + '/edit',
                    name: 'Uredi dodatnu aktivnost: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.dodatna_aktivnost.naziv
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
